module.exports = __webpack_public_path__ + "img/golf_cos2.7aa21997.png";